import { useEffect, type ReactElement } from 'react';

/**
 * Setzt fuer die aktuelle Route ein <meta name="robots" content="noindex, follow">
 * und entfernt es beim Verlassen wieder. Genutzt fuer Rechtsseiten
 * (Impressum/Datenschutz/AGB), die nicht im Suchindex erscheinen sollen.
 *
 * Hinweis: 'noindex' (nicht 'nofollow') ist das richtige Mittel gegen
 * Indexierung. 'follow' laesst Crawler den Footer-Links weiter folgen.
 */
export default function NoIndex(): ReactElement | null {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, follow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return null;
}
